export const CALENDLY_HOME_TENANT_INSURANCE = 'https://www.safehouseinsurance.co.uk/quote?ref=t30'
export const INCOME_PROTECTION_ELEOS = 'https://tlyfe.app.eleos.co.uk/insurance/leads?product=INCOME_PROTECTION';
export const PROPERTY_CLEAN = 'https://store.home.cc/products/end-of-tenancy-clean';
export const CREDIT_SPRING = 'https://www.creditspring.co.uk/tlyfe?utm_source=tlyfe&utm_medium=clickout';
export const tenancy_status = [{ name: "Already moved", key: "CURRENTLY_RENTING" },
{ name: "Moving in next 7 days", key: "NEXT_7_DAYS" },
{ name: "Moving in next 14 days", key: "NEXT_14_DAYS" },
{ name: "Moving in next 30 days", key: "NEXT_30_DAYS" },
{ name: "Moving in more than 30 days", key: "MORE_THAN_30_DAYS_FROM_MOVE_IN" },
{ name: "N/A", key: "NOT_APPLICABLE" }]